import axios from "axios";
import { environment } from "../../environments/environment";

interface SavedJob {
    id: number,
    job_post: number,
    job_title: Record<string, any>,
    city: string,
    company: string,
    salary: number,
    job_type: string,
    job_description: string,
    start_date: string,
    created_at: string,
    updated_at: string,
    admin: Record<string, any>,
    contact_email: string,
    contact_name: string,
    status: string,
    escola_do_mecanico: Record<string, any>
}

interface JobSave {
    job_post_id: number,
    candidate_id: string,
    is_saved: boolean
}

export const listSavedJobs = async (candidate_id?: any): Promise<SavedJob[]> => {
    const response = await axios.get<SavedJob[]>(environment.apiUrl+'/api/candidate/jobpost/saved/'+candidate_id, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const updateSavedJob = async (data: JobSave): Promise<any> => {
    const response = await axios.post<SavedJob[]>(environment.apiUrl+'/api/candidate/jobpost/save', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};
